import { render, staticRenderFns } from "./ProsAndCons.vue?vue&type=template&id=08159758&scoped=true&"
import script from "./ProsAndCons.vue?vue&type=script&lang=ts&"
export * from "./ProsAndCons.vue?vue&type=script&lang=ts&"
import style0 from "./ProsAndCons.vue?vue&type=style&index=0&id=08159758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08159758",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsList: require('/var/www/packages/theme/components/atoms/List.vue').default})
